import logo from "../logo.svg";
import "../App.css";

function Thoughts() {
  return (
    <div className="App">
      <header className="App-header">
        <img src={logo} className="App-logo" alt="logo" />
        <p>
          Thoughts
        </p>
      </header>
    </div>
  );
}

export default Thoughts;